import { render, staticRenderFns } from "./EventFeatures.vue?vue&type=template&id=193663ed&scoped=true&"
import script from "./EventFeatures.vue?vue&type=script&lang=js&"
export * from "./EventFeatures.vue?vue&type=script&lang=js&"
import style0 from "./EventFeatures.vue?vue&type=style&index=0&id=193663ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193663ed",
  null
  
)

export default component.exports